<template>
    <el-dropdown @command="setLanguage" trigger="click" class="language-picker">
        <PrimaryButton :text="currentLanguage" class="tertiary reverse" :naked="true"/>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
                v-for="item in languages"
                :key="item"
                :command="item"
                class="language-picker-item">
            {{item}}
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
import PrimaryButton from '@/components/v3/buttons/PrimaryButton.vue'
import { getModule } from '@/modules/store'
import ConfigStore from '@/modules/config/store/ConfigStore'

export default {
    components: {
        PrimaryButton
    },
    data () {
        return {
            languages: [
                'en',
                'fr',
                'es',
                'pt',
                'nl',
                'de'
            ]
        }
    },
    computed: {
        configStore() {
            return getModule(ConfigStore)
        },
        currentLanguage () {
            return this.configStore.userLanguage
        }
    },
    methods: {
        setLanguage(lang) {
            this.configStore.setUserLanguage(lang)
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";
@import '~assets/v3/css/transition-timing-functions.styl'

.language-picker
    text-transform uppercase
    position fixed
    top 16px
    right 16px + 16px

    .primary-button
        background-color transparent !important
        color #51B2E3 !important
        border-color #51B2E3 !important

        &:hover
            background-color #51B2E3 !important
            color white !important
            border-color #51B2E3 !important

.language-picker-item
    text-transform uppercase

</style>



// WEBPACK FOOTER //
// src/modules/app/components/LanguagePicker.vue